import React from "react";
import {
  Button,
  DateRangePicker,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@jem-open/jem-ui";
import { FIELD_OPTIONS, SOURCE_OPTIONS } from "../utils/employeeAuditLogUtils";

const ALL = "all";

export type AuditLogDateRange = {
  from: Date | undefined;
  to?: Date;
};

export type AuditLogFilterState = {
  dateRange: AuditLogDateRange | undefined;
  field: string;
  source: string;
};

type EmployeeAuditLogFiltersProps = {
  filters: AuditLogFilterState;
  onChange: (filters: AuditLogFilterState) => void;
  onReset: () => void;
};

const EmployeeAuditLogFilters: React.FC<EmployeeAuditLogFiltersProps> = ({
  filters,
  onChange,
  onReset,
}) => (
  <div className="flex flex-wrap items-end gap-xs mb-md">
    <div>
      <DateRangePicker
        label="Date range"
        dateRange={filters.dateRange}
        onDateRangeChange={(dateRange) => onChange({ ...filters, dateRange })}
        placeholder="Pick a date range"
      />
    </div>

    <div className="flex flex-col gap-xxs">
      <span className="text-sm font-medium text-greyscale-text-title">
        Field
      </span>
      <Select
        value={filters.field}
        onValueChange={(field) => onChange({ ...filters, field })}
      >
        <SelectTrigger className="w-[200px]">
          <SelectValue placeholder="All fields" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={ALL}>All fields</SelectItem>
          {FIELD_OPTIONS.map((opt) => (
            <SelectItem key={opt.value} value={opt.value}>
              {opt.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>

    <div className="flex flex-col gap-xxs">
      <span className="text-sm font-medium text-greyscale-text-title">
        Source
      </span>
      <Select
        value={filters.source}
        onValueChange={(source) => onChange({ ...filters, source })}
      >
        <SelectTrigger className="w-[180px]">
          <SelectValue placeholder="All sources" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={ALL}>All sources</SelectItem>
          {SOURCE_OPTIONS.map((opt) => (
            <SelectItem key={opt.value} value={opt.value}>
              {opt.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>

    <Button variant="outline" onClick={onReset}>
      Reset
    </Button>
  </div>
);

export const ALL_FILTER_VALUE = ALL;

export default EmployeeAuditLogFilters;
